import React from "react";
import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";
import { useState } from "react";

const ModalGenerateDemand = (props) => {
  const APP_PATH = process.env.REACT_APP_CONTEXT_PATH;
  return (
    <div>
      <Modal
        show={props.isShowWindow}
        onHide={props.onHide}
        size="lg"
        centered={true}
        backdrop={true}
      >
        <Modal.Body>
          <h4 className="mt-2 mb-4">{props.title}</h4>
          <form>
            <div className="mb-3">
              <p>Total demand</p>
              <input
                type="text"
                className="form-control"
                onChange={props.totalDemand}
                defaultValue={props.totalDemandOldValue}
              ></input>
              {props?.totalDemandOldValue > 0 &&
              !isNaN(parseFloat(props?.totalDemandOldValue / props?.days)) ? (
                <p>
                  {(props?.totalDemandOldValue / props?.days).toFixed(2)} day,
                  {" / "}
                  {(props?.totalDemandOldValue / (props?.days / 7)).toFixed(
                    2
                  )}{" "}
                  week,
                  {" / "}
                  {(props?.totalDemandOldValue / (props?.days / 30)).toFixed(
                    2
                  )}{" "}
                  month
                </p>
              ) : (
                <div className="input-error-modal-tooltip">
                  Input a number greater than "0"
                  <br />
                  <br />
                </div>
              )}
              <p>Variability</p>
              <select
                onChange={props?.handleVariability}
                className="form-select"
                aria-label="Default select example"
              >
                <option defaultValue={"NO"} value="NO">
                  No
                </option>
                <option value="LOW">Low</option>
                <option value="MEDIUM">Medium</option>
                <option value="HIGH">High</option>
              </select>
              <br />
              <p>Distribution</p>
              <div>
                <label className="distribution-label">
                  <img
                    className="pic"
                    src={`${APP_PATH}/demand-distribution/constant-active.svg`}
                    alt=""
                  />
                  <br />
                  <button
                    id="CONSTANT"
                    className="large-button yellow"
                    onClick={props.handleDistribution}
                  >
                    CONSTANT
                  </button>
                </label>
                <label className="distribution-label">
                  <img
                    className="pic"
                    src={`${APP_PATH}/demand-distribution/ramp-up-active.svg`}
                    alt=""
                  />
                  <br />
                  <button
                    id="RAMP_UP"
                    className="large-button yellow"
                    onClick={props.handleDistribution}
                  >
                    RAMP UP
                  </button>
                </label>
                <label className="distribution-label">
                  <img
                    className="pic"
                    src={`${APP_PATH}/demand-distribution/ramp-down-active.svg`}
                    alt=""
                  />
                  <br />
                  <button
                    id="RAMP_DOWN"
                    className="large-button yellow"
                    onClick={props.handleDistribution}
                  >
                    RAMP DOWN
                  </button>
                </label>
                <label className="distribution-label">
                  <img
                    className="pic"
                    src={`${APP_PATH}/demand-distribution/single-peak-active.svg`}
                    alt=""
                  />
                  <br />
                  <button
                    id="SINGLE_PEAK"
                    className="large-button yellow"
                    onClick={props.handleDistribution}
                  >
                    SINGLE PEAK
                  </button>
                </label>
                <label className="distribution-label">
                  <img
                    className="pic"
                    src={`${APP_PATH}/demand-distribution/seasonal-active.svg`}
                    alt=""
                  />
                  <br />
                  <button
                    id="SEASONAL"
                    className="large-button yellow"
                    onClick={props.handleDistribution}
                  >
                    SEASONAL
                  </button>
                </label>
                <label className="distribution-label">
                  <img
                    className="pic"
                    src={`${APP_PATH}/demand-distribution/scattered-active.svg`}
                    alt=""
                  />
                  <br />
                  <button
                    id="SCATTERED"
                    className="large-button yellow"
                    onClick={props.handleDistribution}
                  >
                    SCATTERED
                  </button>
                </label>
              </div>
            </div>
          </form>
        </Modal.Body>
        <Modal.Footer>
          <button className="large-button grey" onClick={props.onHide}>
            CLOSE
          </button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};
export default ModalGenerateDemand;
